import { useCallback } from 'react';

import { useGetDataByAuth } from '@interlayer/js/app/hooks/auth/hooks/useGetDataByAuth';
import { useGetDataByFormFactor } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';

import { TDeviceAndAuthProps } from './types';

export const useGetDataByDeviceAndAuth = () => {
    const getDataByAuth = useGetDataByAuth();
    const getDataByFormFactor = useGetDataByFormFactor();

    return useCallback((data: TDeviceAndAuthProps) => {
        const dataByAuth = getDataByAuth({
            logInData: {
                mobile: data.logInMobile,
                tablet: data.logInTablet,
                desktop: data.logInDesktop,
                fallback: data.logInFallback || data.fallback
            },
            logOutData: {
                mobile: data.logOutMobile,
                tablet: data.logOutTablet,
                desktop: data.logOutDesktop,
                fallback: data.logOutFallback || data.fallback
            }
        });

        return getDataByFormFactor(dataByAuth);
    }, [getDataByAuth, getDataByFormFactor]);

};
